import goalIcon from 'assets/images/icons/events/mål.svg';
import penaltyIcon from 'assets/images/icons/events/straffe.svg';
import freeKickIcon from 'assets/images/icons/events/frispark.svg';
import yellowCardIcon from 'assets/images/icons/events/gultkort.svg';
import redCardIcon from 'assets/images/icons/events/rodtkort.svg';
import playerOutIcon from 'assets/images/icons/events/spillerbytte.svg';
import cornerIcon from 'assets/images/icons/events/corner.svg';
import offsideIcon from 'assets/images/icons/events/offside.svg';
import injuryTimeIcon from 'assets/images/icons/events/tillegstid.svg';
import varIcon from 'assets/images/icons/events/VAR.svg';
import annulledIcon from 'assets/images/icons/events/annuler.svg';
import secondYellowCardIcon from 'assets/images/icons/events/to_gulekort.svg';
import importantIcon from 'assets/images/icons/events/important.svg';

const eventIcons: Record<number, string> = {
  2: goalIcon,
  3: redCardIcon,
  4: yellowCardIcon,
  6: offsideIcon,
  8: goalIcon,
  9: penaltyIcon,
  10: goalIcon,
  11: importantIcon,
  12: secondYellowCardIcon,
  13: annulledIcon,
  23: playerOutIcon,
  25: cornerIcon,
  41: freeKickIcon,
  123: varIcon,
  126: injuryTimeIcon,
  130: importantIcon,
};

export default eventIcons;
